<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <b-dropdown text="Action" variant="primary" class="mr-1">
            <b-dropdown-item @click="settlement" :disabled="model.rrd_dt!=null">
              <i class="fa fa-money"></i>Settlement
            </b-dropdown-item>
            <b-dropdown-item @click="printPDFMemoPelunasan">
              <i class="fa fa-print"></i>Print Memo Pelunasan
            </b-dropdown-item>
            <b-dropdown-item @click="confirmposting({bulk:false})" :disabled="!model.pelunasankey && model.ispaid!=1">
              <i class="fa fa-upload"></i>Posting Selected
            </b-dropdown-item>
            <b-dropdown-item @click="confirmposting({bulk:true})" >
              <!-- :disabled="!model.start && !model.end" -->
              <i class="fa fa-upload"></i>Posting Bulk
            </b-dropdown-item>
          </b-dropdown>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i> Filter
          </button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <!-- <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button> -->
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">Debitur</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.CustName" placeholder="Debitur Name"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">Debitur No (CIF)</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.CustCode" placeholder="Customer No (CIF)"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.nomor" placeholder="No Kontrak"></b-form-input>
              </b-input-group>
            </b-col>
            
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">No. Aggrement</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.agreement" placeholder="No Agreement"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">No. Memo</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.nosurat"></b-form-input>
              </b-input-group>
            </b-col>
            
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">Status Memo</label>
                </b-input-group-prepend>
                <b-form-select v-model="tblData.status_memo" :plain="true" :options="statuses_memo"></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="6">
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">Tgl. Pelunasan</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
                <b-input-group-prepend>
                  <span class="input-group-text">until</span>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label class="label-custome">Tgl. RRD</label>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.rrd_dt1" type="date"></b-form-input>
                <b-input-group-prepend>
                  <span class="input-group-text">until</span>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.rrd_dt2" type="date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend
                  ><label class="label-custome"
                    >Status Posting&nbsp;</label
                  ></b-input-group-prepend
                >
                <b-form-select
                  v-model="tblData.posting"
                  :plain="true"
                  :options="postingStatus"
                ></b-form-select>
            <b-input-group-append>
              <b-button variant="success" size="sm" @click="refresh()" class="ml-3">
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button
                variant="secondary"
                size="sm"
                class="ml-2"
                @click="clearFilter()"
              >Clear Filter</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        :busy="isBusy"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(index)="data">{{ data.index+1 }}</template>
        <template v-slot:cell(nosurat)="data">
          <div  :class="data.item.posting==1?'p-1':'bg-warning text-dark p-1'">{{ data.item.nosurat}}</div>
        </template>
        <template
          v-slot:cell(tglpelunasan)="data"
        >{{ data.item.tglpelunasan | moment("DD MMM YYYY") }}</template>
        <template v-slot:cell(ttlinstalment)="data">{{ data.item.ttlinstalment | numFormat('0,0.00') }}</template>
        <template v-slot:cell(ttllatecharge)="data">{{ data.item.ttllatecharge | numFormat('0,0.00') }}</template>
        <template v-slot:cell(diskon_amount)="data">{{ data.item.diskon_amount | numFormat('0,0.00') }}</template>
        <template v-slot:cell(ttlpayment)="data">{{ data.item.ttlpayment | numFormat('0,0.00') }}</template>
        <template v-slot:cell(ttlpayment_diskon)="data">{{ data.item.ttlpayment_diskon | numFormat('0,0.00') }}</template>
        <template v-slot:cell(cicilan_pelunasan)="data">{{ data.item.cicilan_pelunasan | numFormat('0,0.00') }}</template>
        <template v-slot:cell(rrd_dt)="data">{{ data.item.rrd_dt | moment('DD MMM YYYY')}}</template>
        <template v-slot:cell(wo_status)="data"><span :class="data.item.wo_status==1?'bg-danger p-1':''">{{ data.item.wo_status==1?'ON':'OFF'}}</span></template>

        
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width:80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showPostingConfirm" title="Posting Transaction?" :centered="true" @ok="postingData">
        <p class="mb-1">1 record is about to be Posting</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure to doing this ?</p>
      </b-modal>
      <b-modal v-model="showPostingBulkConfirm" title="Posting Bulk Transaction?" :centered="true" @ok="postingBulkData">
        <p class="mb-1">Records (paid) is about to be Posting</p>
        <b-input-group >
          <b-input-group-prepend><label>Trx. Periode (Post Date)</label></b-input-group-prepend>
        </b-input-group>
        <b-input-group >
          <b-form-input v-model="model.start" type="date" ></b-form-input>
          <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
          <b-form-input v-model="model.end" type="date" ></b-form-input>
        </b-input-group>
        <p class="font-weight-bold m-0 text-danger">Are you sure to doing this ?</p>
      </b-modal>

      
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import task from "../../apis/task";
import pelunasan from "../../apis/pelunasanpinjaman";
import crud from "../../apis/crud";

toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      // start print
      isLoading: false,
      showReport: false,
      reportUrl: "",
      // end print
      showApprovalConfirm: false,
      showPostingConfirm:false,
      showPostingBulkConfirm:false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalcancelConfirm: false,
      model: {
        start:'',end:''
      },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        // tgl1: this.$store.state.user.tglaktif,
        // tgl2: this.$store.state.user.akhirbln,
        rrd_dt1:'',rrd_dt2:'',
        sortBy: "tglpelunasan",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        nosurat:"",CustName:"",CustCode:"",nomor:"",agreement:"",status_memo:"",posting:-1
      },
      statuses_memo: [
        { value: "", text: "--- ALL ---" },
        // { value: "Send Approval", text: "Send Approval" },
        // { value: "isreviewed", text: "Reviewed" },
        { value: "Approved", text: "Approved" },
        // { value: "Rejected", text: "Rejected" },
        // { value: "Expired", text: "Expired" },
        { value: "Paid", text: "Paid" },
      ],
      collectors: [{ value: "", text: "--- ALL ---" }],
      modelkredit: [
        { value: "", text: "--- ALL ---" },
        { value: "PAB", text: "Angsuran Bulanan" },
        { value: "PRK", text: "Rekening Koran" },
      ],
      kolStatus: [
        { value: "", text: "--- ALL ---" },
        { value: "kol-1", text: "KOL-1" },
        { value: "kol-2", text: "KOL-2" },
        { value: "kol-3", text: "KOL-3" },
        { value: "kol-4", text: "KOL-4" },
        { value: "kol-5", text: "KOL-5" },
      ],
      statuses: [
        { value: "", text: "--- ALL ---" },
        { value: "LIV", text: "Live"},
        { value: "ICP", text: "Incomplete Payment"},
        { value: "RRD", text: "Ready Release Document"},
      ],
      wostatus: dropdown.woStatus,
      postingStatus: dropdown.postingStatus,
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "nosurat",
          label: "No. Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "no_agreement",
          label: "No. Agreement",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },

        {
          key: "CustCode",
          label: "CIF",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur Name",
          thStyle: "width:150px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "tglpelunasan",
          label: "Tgl. Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "ttlpayment",
          label: "Ttl. Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "cicilan_pelunasan",
          label: "Ttl. Cicilan Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        
        {
          key: "contract_status",
          label: "Status Pinjaman",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "wo_status",
          label: "WO",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "rrd_dt",
          label: "RRD Date",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
         {
          key: "status_memo",
          label: "Status Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "createby",
          label: "Issued By",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "modified_by",
          label: "Modified By",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  watch:{
    "tblData.tgl1":function(newval) {
      this.model.start=moment(newval).format('YYYY-MM-DD');
    },
    "tblData.tgl2":function(newval) {
      this.model.end=moment(newval).format('YYYY-MM-DD');
    },
  },
  async created() {
    // this.isBusy = true;
    // this.data();
    const collSet = {
      tablename: "vwcollector",
      // page: 1,
      // limit: 20,
      // total: 0,
    };
    const collector = await crud.list(collSet);
    collector.map((dt) => {
      this.collectors.push({ value: dt.collector_id, text: dt.crewname });
    });

    if(this.$route.params&&this.$route.params.contract_status){
      this.tblData.contract_status = this.$route.params.contract_status;
      this.refresh();
    }

  },
  methods: {
    saveFilter() {
      const keys = ['sortBy', 'sortDir', 'CustName','CustCode', 'collectability', 'collector_id', 'model_pinjaman', 
                'tglsurat1', 'tglsurat2','tgl1', 'tgl2','rrd_dt1', 'rrd_dt2','nomor','status_memo', 'agreement', 'contract_status', 'wo_status','nosurat','pinjamankey'];
      let filtered = false;
      const settlmemopelunasan={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              settlmemopelunasan[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          settlmemopelunasan.page=this.tblData.page;
          settlmemopelunasan.limit=this.tblData.limit;
          settlmemopelunasan.sortBy=this.tblData.sortBy;
          settlmemopelunasan.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.settlmemopelunasan=settlmemopelunasan;
          this.$store.commit("filter", filter);
      }
    },  
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }

      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    data: async function (ctx) {
      try {
        const filter = this.$store.state.filter;
        console.log('filter',filter);
        let filtered=false;
        for (var key in filter.settlmemopelunasan) {
            this.tblData[key] = filter.settlmemopelunasan[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.settlmemopelunasan;
          this.$store.commit("filter", filter);
        }
        const list = await pelunasan.listreadytosettlement(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.tblData.page=1;
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.CustCode = "";
      this.tblData.CustName = "";
      this.tblData.collectability = "";
      this.tblData.collector_id = "";
      this.tblData.model_pinjaman = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.nomor = "";
      this.tblData.status = "";
      this.tblData.agreement = "";
      this.refresh();
    },
    async exportxls() {
      try {
        await pelunasan.exportxlsWO(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async printPDFMemoPelunasan() {
      if (this.model.pelunasankey) {
        this.isLoading = true;
        try {
          this.reportUrl = await pelunasan.printPDFMemoPelunasan(this.model.pelunasankey);
          this.isLoading = false;
          this.showReport = true;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message, "ERROR", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to print");
      }
    },
    async edit() {
      if (this.model.pelunasankey) {
        this.saveFilter();
        router.push({
          name: "loan.pelunasanmemofrm",
          params: { pelunasankey: this.model.pelunasankey },
        });
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },
    async settlement(){
      if (this.model.pelunasankey) {
        if(this.model.send2wf==0){
          toastr.warn("memo belum diajukan untuk approval");
        }else{
          if(this.model.iscomplete ==1 && this.model.issuccess==1){
            this.saveFilter();
            router.push({
              name: "loan.pelunasanwofrm",
              params: { pelunasankey: this.model.pelunasankey },
            });
          }else if(this.model.iscomplete ==0 && this.model.issuccess==0){
            toastr.warn("memo belum mendapatkan persetujuan");
          }else if(this.model.iscomplete ==1 && this.model.isreject==1){
            toastr.warn("memo pelunasan persetujuan rejected (not approve)");
          }
        }
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },
    approvalConfirm: async function () {
        if (this.model.pelunasankey) {
            if (this.model.send2wf==1) {
              try {
                const data = await task.approvalhistory({key: this.model.pelunasankey});
                this.approvalHistory=data;                
              } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                
              }
            }
            this.model.requestdate = this.model.requestdate ? moment(this.model.requestdate).format('YYYY-MM-DD') : '';
                this.showApprovalConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.pelunasankey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await pelunasan.approval(formData);
            this.model.send2wf=1;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await pelunasan.approvalUndo(this.model);
            this.model.send2wf=0;
            this.showApprovalConfirm = false;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.pelunasankey) {
          this.isLoading=true;
          try {
              this.reportUrl= await task.approvalprint({key: this.model.pelunasankey});
              this.showReport=true;
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    confirmposting({bulk}){
        if(bulk){
           this.showPostingBulkConfirm=true;
        }else{
           if (this.model.pelunasankey) {
           if(this.model.ispaid==1){
              this.showPostingConfirm=true;
           }else{
             toastr.warn('Pilih memo dengan status "PAID"');
           }
         } else {
            toastr.warn('Please select a row that want to be posting');
          }
        }
        
    },
    async postingData(){ 
      try{
        this.isLoading=true;
        await pelunasan.postingsettlement(this.model);
        this.refresh();
        this.isLoading=false;
      } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    }, 
    async postingBulkData(){ 
      try{
        this.isLoading=true;
        await pelunasan.postingbulksettlement(this.model);
        this.refresh();
        this.isLoading=false;
      } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },      
    close() {
      router.push("home");
    },
  },
};
</script>